import PropTypes from 'prop-types';
import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

export class LoadingButton extends React.Component {
  state = {
    isLoading: false,
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleOnClick = async () => {
    const { onClick, onValidation } = this.props;

    if (onValidation()) {
      this.setState({ isLoading: true });
      try {
        await onClick();
      } finally {
        if (this._isMounted) this.setState({ isLoading: false });
      }
    }
  };

  render() {
    const { variant, children, loadingText } = this.props;
    const { isLoading } = this.state;

    return (
      <Button
        variant={variant}
        onClick={() => this.handleOnClick()}
        disabled={isLoading}
      >
        { !isLoading && (<span>{ children }</span>) }
        { isLoading && (
          <>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="mr-1"
            />
            { loadingText }
          </>
        )}
      </Button>
    );
  }
}

LoadingButton.defaultProps = {
  loadingText: 'Loading...',
  variant: undefined,
  onClick: () => new Promise((_resolve, _reject) => {}),
  onValidation: () => true,
  children: 'Button',
};

LoadingButton.propTypes = {
  loadingText: PropTypes.string,
  variant: PropTypes.string,
  onClick: PropTypes.func,
  onValidation: PropTypes.func,
  children: PropTypes.string,
};

export default LoadingButton;
